import React, { useEffect, useState } from 'react'
import loadable from '@loadable/component'
import PlayVideo from './play-video.svg'
import * as styles from './player.module.scss'
const ReactPlayer = loadable(async () => await import('react-player'))

const Player = ({
  video,
  autoPlay = true,
  preview,
  customClass = '',
  muted = false,
  loop = false,
  controls = true,
  playOnHover = false,
  viewOnScroll = false,
  classes = {
    wrapper: ''
  }
}) => {
  const [isFixedVideo, setIsFixedVideo] = useState(false)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 850) {
          setIsFixedVideo(true)
        } else {
          setIsFixedVideo(false)
        }
      })
    }
  }, [])

  const playing = !!(autoPlay || playOnHover)

  const handleTracking = () => {
    if (window?._paq) {
      // @see https://developer.matomo.org/guides/media-analytics/setup
      window._paq.push(['MediaAnalytics::scanForMedia'])
    }
  }

  const playImage = (
    <div className="play">
      <img src={PlayVideo} alt="play" />
    </div>
  )

  const classFixed = isFixedVideo ? styles.videoFixed : ''

  if (viewOnScroll) {
    const classNameWrapper = !!classes?.wrapper
      ? `${styles.playerwrapper} ${classFixed} ${classes?.wrapper}`
      : `${styles.playerwrapper} ${classFixed}`

    return (
      <div>
        <div className={classNameWrapper}>
          <ReactPlayer
            url={video}
            config={{
              youtube: {
                playerVars: { showinfo: 0, rel: 0 }
              }
            }}
            className={customClass !== '' ? styles[customClass] : ''}
            light={playOnHover ? false : preview}
            playing={playing}
            playIcon={playImage}
            width="100%"
            height="100%"
            controls={controls}
            muted={muted}
            pip={false}
            loop={loop}
            onReady={handleTracking}
          />
        </div>
      </div>
    )
  }

  return (
    <div>
      <div
        className={[styles.playerwrapper, classes?.wrapper]
          .filter(Boolean)
          .join(' ')}
      >
        <ReactPlayer
          url={video}
          config={{
            youtube: {
              playerVars: { showinfo: 0, rel: 0 }
            }
          }}
          className={customClass !== '' ? styles[customClass] : ''}
          light={playOnHover ? false : preview}
          playing={playing}
          playIcon={playImage}
          width="100%"
          height="100%"
          controls={controls}
          muted={muted}
          pip={false}
          loop={loop}
          onReady={handleTracking}
        />
      </div>
    </div>
  )
}

export default Player
